<ng-content select="[xBranding]"></ng-content>

<header *ngIf="heading" class="border-bottom-color">
  <h3>{{ heading }}</h3>
  <div class="actions">
    <ng-content select="[xHeaderAction]"></ng-content>
  </div>
</header>

<div class="body">
  <ng-content></ng-content>
</div>

<footer class="border-top-color">
  <ng-content select="x-error-operation"></ng-content>

  <div class="actions">
    <ng-content select="[xSheetAction]"></ng-content>
  </div>
</footer>
